<template>
  <BButton :block="block"
           :disabled="disabled"
           :size="size"
           :title="title === null ? text : title"
           :href="href"
           :target="target"
           :to="to === null ? '' : to"
           :type="type"
           :variant="variant"
           :tabindex="tabindex"
           @click="$emit('click', $event)">
    <Icon v-if="prependIcon"
          :size="iconSize"
          :name="iconName"
          :title="title === null ? text : title">
    </Icon>
    <span v-if="text"
          :class="[textClass, { 'ml-2': prependIcon, 'mr-2': appendIcon }]">{{ text }}</span>
    <Icon v-if="appendIcon"
          :size="iconSize"
          :name="iconName"
          :title="title === null ? text : title">
    </Icon>
    <Badge v-if="badge !== null"
           :text="badge">
    </Badge>
  </BButton>
</template>

<script>
  import { BButton } from 'bootstrap-vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import Icon from './Icon.vue';
  import Badge from './Badge.vue';

  export default {
    name: 'ButtonElement',
    compatConfig: {
      MODE: 3,
      COMPONENT_FUNCTIONAL: true,
    },
    components: {
      Icon,
      Badge,
      BButton,
    },
    props: {
      badge: {
        type: String,
        default: null,
      },
      block: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      iconName: {
        type: String,
        default: null,
      },
      iconAppend: {
        type: Boolean,
        default: false,
      },
      iconSize: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      text: {
        type: String,
        required: true,
      },
      textClass: {
        type: String,
      },
      title: {
        type: String,
        default: null,
      },
      href: {
        type: String,
        default: null,
      },
      tabindex: {
        type: String,
      },
      target: {
        type: String,
      },
      to: {
        type: String,
        default: null,
      },
      type: {
        type: String,
        default: 'button',
      },
      variant: {
        type: String,
        default: BootstrapVariant.PRIMARY,
      },
    },
    emits: ['click'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    computed: {
      appendIcon() {
        return this.iconName !== null && this.iconAppend === true;
      },
      prependIcon() {
        return this.iconName !== null && this.iconAppend === false;
      },
    },
  };
</script>
